export const createFeedback = (feedback) => {
  let token = "Bearer " + localStorage.getItem("jwt")
  return fetch("/api/v1/feedbacks/create", {
    method: "POST",
    headers: {
      "Authorization": token,
      "Content-Type": "application/json",
      'Accept': 'application/json'
    },
    body: JSON.stringify(feedback)
  })
  .then(res => res.json())
}

